import { Component, EventEmitter, Input, Output } from "@angular/core";
import { JobOffer, StageUpdateEvent } from "../../../../../../api/job-offer/job-offer.types";
import { Router } from "@angular/router";

@Component({
  selector: "mh-job-offer-list-archived",
  templateUrl: "./job-offer-list-archived.component.html",
  styleUrls: ["./job-offer-list-archived.component.less"],
})
export class JobOfferListArchivedComponent {
  @Input() jobOfferList: Array<JobOffer> = [];
  @Output() unArchiveJobOffer = new EventEmitter<JobOffer>();
  @Output() stageUpdated = new EventEmitter<StageUpdateEvent>();

  constructor(private router: Router) {}

  onUnArchive(entity: JobOffer) {
    this.unArchiveJobOffer.emit(entity);
  }

  onStageUpdated(event: StageUpdateEvent) {
    this.stageUpdated.emit(event);
  }

  navigateToMatches(offerId: string) {
    this.router.navigate(["/", "mission-partner", "job-offers", "matches", offerId]);
  }
}
